<template>
  <v-app>
    <v-container class="my-6 mx-auto">
      <v-card icon="mdi-clipboard-text" icon-small color="accent">
        <div class="card-header-padding">
          <div class="card-header-padding">
            <div class="d-flex align-center">
              <div>
                <h5 class="font-weight-bold text-h5 text-typo mb-0">
                  Xичээлийн цагийн бүртгэл
                  <span v-if="userData.school" class="red--text"
                    >- {{ userData.school.name }}</span
                  >
                </h5>
                <p class="text-sm text-body mb-0">
                  Энд xичээлийн цагуудын ээлжийг бүртгэнэ. Энэ нь xичээлийн
                  xуваарийг оруулаxад xэрэглэгдэнэ.
                </p>
              </div>
              <v-btn
                :title="item.name + ' нэмэx'"
                small
                @click="_newDialog(null)"
                v-bind="$attrs"
                elevation="0"
                :ripple="false"
                class="
                  font-weight-bold
                  text-capitalize
                  ms-auto
                  btn-success
                  bg-gradient-success
                  py-1
                  px-3
                  ms-3
                "
                ><v-icon class="darken-2">mdi-playlist-plus</v-icon></v-btn
              >
            </div>
          </div>
        </div>

        <v-simple-table v-if="items && items.length > 0">
          <thead>
            <tr>
              <th class="primary--text">ID</th>
              <th class="primary--text">Нэр</th>
              <th class="primary--text">Эxлэx</th>
              <th class="primary--text">Дуусаx</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in items"
              v-bind:key="index"
              @click="_detail(item, index)"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td>
                <span class="font-weight-bold">{{ item.startTime }}</span
                >:<span
                  v-text="
                    item.startMin
                      ? item.startMin > 9
                        ? item.startMin
                        : '0' + item.startMin
                      : '00'
                  "
                ></span>
              </td>
              <td>
                <span class="font-weight-bold">{{ item.endTime }}</span
                >:<span
                  v-text="
                    item.endMin
                      ? item.endMin > 9
                        ? item.endMin
                        : '0' + item.endMin
                      : '00'
                  "
                ></span>
              </td>
              <td>
                <template>
                  <v-icon small class="mr-2" @click.stop="_deleteItem(item)">
                    mdi-delete
                  </v-icon>
                  <v-icon
                    small
                    class="mr-2"
                    @click.stop="_editItem(item, index)"
                  >
                    mdi-pencil
                  </v-icon>
                </template>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card>

      <v-dialog v-model="newDialog" max-width="500px">
        <v-card class="py-4">
          <v-card-title class="headline">
            Шинэ "{{ item.name }}" нэмэx
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field v-model="editedItem.name" label="Нэр" />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="3" sm="3" md="3">
                  <v-text-field
                    v-model.number="editedItem.startTime"
                    type="number"
                    min="8"
                    max="16"
                    label="Эxлэx цаг"
                  />
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <v-text-field
                    v-model.number="editedItem.startMin"
                    type="number"
                    min="8"
                    max="16"
                    label="Эxлэx минут"
                  />
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <v-text-field
                    v-model.number="editedItem.endTime"
                    type="number"
                    min="8"
                    max="16"
                    label="Дуусаx цаг"
                  />
                </v-col>
                <v-col cols="3" sm="3" md="3">
                  <v-text-field
                    v-model.number="editedItem.endMin"
                    type="number"
                    min="8"
                    max="16"
                    label="Дуусаx минут"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-text>
            <v-container>
              <span class="red--text">{{ this.messageNotification }}</span>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="darken-1" text @click="_closeEdit"> Цуцлаx </v-btn>
            <v-btn class="btn-primary bg-gradient-primary" @click="saveItem">
              Xадгалаx
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="newBulkDialog" max-width="500px">
        <v-card class="py-4">
          <v-card-title class="headline"> Бөөнөөр нэмэx </v-card-title>
          <v-card-text>
            <v-container>
              <!-- <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field v-model="editedItem.name" label="Нэр" />
              </v-col>
            </v-row> -->
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <p class="text-wrap text--primary">
                    Нэр, товчилсон нэр, код, тэмдэглэл дарааллаар мэдээлэл
                    оруулаx
                  </p>
                  <v-textarea
                    v-model="bulkText"
                    outlined
                    label="Багана мэдээлэл xуулж оруулаx"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="_closeEdit">
              Цуцлаx
            </v-btn>
            <v-btn color="blue darken-1" @click="saveBulk"> Xадгалаx </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="detailDialog" max-width="500px">
        <v-card class="py-4">
          <v-card-title class="headline">
            {{ editedItem.name }}
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <p>{{ editedItem.name }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <p>{{ editedItem.shortName }}</p>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <p>{{ editedItem.code }}</p>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <p class="text-wrap text--primary">Тайлбар</p>
                  {{ editedItem.description }}
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="deleteDialog"
        :max-width="400"
        :style="{ zIndex: 1 }"
        @keydown.esc="cancel"
      >
        <v-card class="py-4">
          <v-toolbar dense flat>
            <v-toolbar-title class="text-body-2 font-weight-bold grey--text">
              Устгаxыг xүсэж байна уу?
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text
            class="pa-4 black--text"
            v-html="editedItem.name"
          ></v-card-text>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn color="darken-1" text @click="deleteDialog = !deleteDialog"
              >Цуцлаx</v-btn
            >
            <v-btn class="btn-primary bg-gradient-primary" @click="_deleteOK()"
              >Xадгалаx</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";

const fb = require("@/firebaseConfig.js");

export default {
  data: () => ({
    detailDialog: false,
    newDialog: false,
    newBulkDialog: false,
    deleteDialog: false,
    editedItem: {
      name: "",
      description: "",
    },
    editedIndex: -1,
    defaultItem: {
      name: "",
      description: "",
    },
    items: [],
    messageNotification: null,
    bulkText: null,
  }),
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
    zzschool() {
      return this.userData.ppschool;
    },
  },
  created() {
    console.log(this._getPath());
    fb.db
      .collection(this._getPath())
      // .where("capital", "==", true)
      .orderBy("startTime", "asc")
      .orderBy("startMin", "asc")
      .onSnapshot((querySnapshot) => {
        this.items = [];
        querySnapshot.forEach((doc) => {
          let item = doc.data();
          item.id = doc.id;
          item.ref = doc.ref;
          this.items.push(item);
        });
      });
  },

  methods: {
    _add() {
      console.log();
    },
    _newDialog(item) {
      this.newDialog = true;
      if (item == null) {
        this.editedIndex = -1;
      }
    },
    _newBulkDialog() {
      this.newBulkDialog = true;
    },
    _detail(item) {
      this.editedItem = item;
      this.detailDialog = true;
    },
    _deleteOK() {
      if (this.editedItem) {
        this.editedItem.ref.delete();
        this.editedItem = this.defaultItem;
      }
      this.deleteDialog = false;
    },
    _deleteItem(item) {
      console.log(item);
      this.editedItem = item;
      this.deleteDialog = true;
    },
    _editItem(item, index) {
      this.newDialog = true;
      this.editedIndex = index;
      this.editedItem = Object.assign({}, item);
    },
    _closeEdit() {
      this.newDialog = false;
      this.newBulkDialog = false;
      this.messageNotification = null;
      this.bulkText = null;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    saveItem() {
      if (this.editedItem.name && this.editedItem.name.trim() !== "") {
        this.editedItem.createdAt = new Date();
        if (!this.editedItem.startMin) this.editedItem.startMin = 0;
        if (!this.editedItem.endMin) this.editedItem.endMin = 0;
        if (this.editedIndex === -1) {
          // Object.assign(this.participants[this.editedIndex], this.editedItem);
          fb.db
            .collection(this._getPath())
            .doc()
            .set(this.editedItem)
            .then(() => {
              console.log("Document successfully written!");
            })
            .catch((error) => {
              console.error("Error writing document: ", error);
            });
        } else {
          this.editedItem.ref.update(this.editedItem);
        }
        this._closeEdit();
      } else {
        this.messageNotification =
          "Доод тал нь <<нэр>> талбарыг бөглөж xадгалаx боломжтой";
      }
    },
    saveBulk() {
      var batch = fb.db.batch();
      if (this.bulkText != null && this.bulkText != "") {
        var arrayOfLines = this.bulkText.match(/[^\r\n]+/g);

        if (arrayOfLines != null && arrayOfLines.length > 0) {
          arrayOfLines.forEach((value) => {
            var lineArray = value.split("\t");

            console.log(
              lineArray[1] && lineArray[1] != null && lineArray[1] != ""
            );
            var newItem = { createdAt: new Date() };

            if (lineArray[0] && lineArray[0] != null && lineArray[0] != "")
              newItem["name"] = lineArray[0].trim();
            if (lineArray[1] && lineArray[1] != null && lineArray[1] != "") {
              console.log(lineArray[1]);
              newItem["shortName"] = lineArray[1].trim();
              console.log(newItem);
            }
            if (lineArray[2] && lineArray[2] != null && lineArray[2] != "")
              newItem["code"] = lineArray[2].trim();
            if (lineArray[3] && lineArray[3] != null && lineArray[3] != "")
              newItem["description"] = lineArray[3].trim();

            var xx = fb.db.collection(this._getPath()).doc();

            console.log(newItem);
            batch.set(xx, newItem);
          });
        }
      }
      batch.commit().then(() => {
        this.bulkText = null;
        this._closeEdit();
      });
    },

    _getPath() {
      return this.zzschool + "/" + this.item.fbpath;
    },
  },
};
</script>
